import ApiServiceBase from "../ApiServiceBase";
import ApiService from "../ApiService";
import { ServiceType } from "../ServiceType.data";
import {
  VerifyOtpRequest,
  GenerateOtpPayload,
  OtpResponse
} from "./OtpService.type";

const service: ApiServiceBase = new ApiService(ServiceType.Account, true);

class OtpService {
  public generate(
    data: GenerateOtpPayload
  ): OtpResponse | Promise<OtpResponse> {
    const { phoneNumber, register } = data;
    const payload = { phone_number: phoneNumber, register };
    return service.post({ route: ["generate-otp/customer-portal"] }, payload);
  }

  public verify(data: VerifyOtpRequest): OtpResponse | Promise<OtpResponse> {
    const { phoneNumber, otp } = data;
    const verifyPayload = {
      phone_number: phoneNumber,
      otp
    };
    return service.post(
      { route: ["validate-otp/customer-portal"] },
      verifyPayload
    );
  }
}

const otpService = new OtpService();
export default otpService;
